import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { logout } from '../../features/account/redux/action';
import ModalNoti from '../modalNoti';
import './index.css';

function DropDownMenuHeader() {
  const dispatch = useDispatch();
  const [showLogoutPopup, setShowLogoutPopup] = useState(false);

  const hidePopup = () => {
    setShowLogoutPopup(false);
  }
  return (
    <>
      <div className="dropdown_header">
        <ul>
          <li>
            <a onClick={() => setShowLogoutPopup(true)}>
              <img src="./dashboard/icon_logout.png" alt="" />
              <p>Đăng xuất</p>
            </a>
          </li>
        </ul>
      </div>
      <ModalNoti 
        show={showLogoutPopup}
        onHide={hidePopup}
        closeButton={false}
        content={'Bạn muốn thoát khỏi hệ thống?'}
        leftButton={{
          onClick: () => {
            hidePopup();
          },
          content: 'Đóng'
        }}
        rightButton={{
          onClick: () => {
            dispatch(logout());
          },
          content: 'Đồng ý'
        }}
      ></ModalNoti>
    </>
  )
}

export default DropDownMenuHeader;